/**
 * @fileoverview จับคอลัมน์ของไฟล์ Excel ตาม "ชื่อหัวคอลัมน์" แทนตำแหน่ง (ใช้ร่วม Import Center และนำเข้าสต็อก)
 * @module utils/headerMatch
 *
 * กติกาเทียบชื่อ: ไม่สนตัวพิมพ์ / ช่องว่าง / เครื่องหมาย * / การขึ้นบรรทัดใหม่ (\r\n)
 * เซลล์หัวสองภาษา (ไทย + อังกฤษคนละบรรทัด) แตกตามบรรทัดแล้วเทียบแต่ละส่วน ตรงภาษาใดก็รับ
 */

/** ตัดช่องว่าง / * / ตัวพิมพ์ ให้เหลือแต่ตัวอักษรไว้เทียบ */
export const normHeaderCell = (v) => String(v ?? "").replace(/\*/g, "").replace(/\s+/g, "").toLowerCase();

/** เซลล์หัว -> ชุดข้อความที่เทียบได้ (ทั้งเซลล์ + แต่ละบรรทัด) */
const headerKeys = (cell) => {
  const text = String(cell ?? "");
  const keys = new Set();
  const whole = normHeaderCell(text);
  if (whole) keys.add(whole);
  text.split(/\r\n|\r|\n/).forEach((part) => {
    const k = normHeaderCell(part);
    if (k) keys.add(k);
  });
  return keys;
};

/**
 * @param {any[]} headerRow แถวหัวคอลัมน์ของไฟล์
 * @param {Array<{en?: string, th?: string, aliases?: string[], required?: boolean}>} columns
 * @returns {{ colIndex: number[], missing: string[] }} colIndex = ตำแหน่งในไฟล์ของแต่ละ column (-1 = ไม่พบ),
 *   missing = ชื่อ (en) ของคอลัมน์บังคับที่ไม่พบ · คอลัมน์ในไฟล์ที่ไม่อยู่ใน columns ถูกข้าม
 */
export const matchColumnsByHeader = (headerRow, columns) => {
  const cellKeys = (headerRow || []).map(headerKeys);
  const used = new Set();
  const colIndex = columns.map((c) => {
    const names = [c.en, c.th, ...(c.aliases || [])].map(normHeaderCell).filter(Boolean);
    // หัวซ้ำ -> เอาตำแหน่งที่ยังไม่ถูกคอลัมน์อื่นใช้
    const idx = cellKeys.findIndex((keys, i) => !used.has(i) && names.some((n) => keys.has(n)));
    if (idx >= 0) used.add(idx);
    return idx;
  });
  const missing = columns.filter((c, i) => c.required && colIndex[i] < 0).map((c) => c.en || c.th);
  return { colIndex, missing };
};
